import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import navItems from "../utils/routes/navItens";
import { useAuth } from "../contexts/AuthContext";
import logoAsside from "../assets/logoAsside.png";

const Asside = () => {
  const [isHovered, setIsHovered] = useState(null);
  const location = useLocation();
  const { user } = useAuth();

  return (
    <div className=" bg-[#F2F2F2] rounded-l-xl md:col-span-2 lg:col-span-2 xl:col-span-1">
      <div className="h-[100px] flex justify-center items-center">
        <NavLink to="/dashboard">
          <img src={logoAsside} alt="logo" />
        </NavLink>
      </div>
      <div>
        <nav>
          <ul>
            {navItems.map((item, index) => {
              if (user && user.accessType === "AGENT" && item.name !== "Cargas")
                return;
              return (
                <li key={index} className="h-[60px]">
                  <NavLink
                    className={({ isActive }) =>
                      `relative flex items-center font-bold rounded-r-xl ${
                        isActive || location.pathname.startsWith(item.path)
                          ? "bg-[#EDEDED] text-[#FF9533] h-full after:absolute after:left-0 after:top-0 after:h-full after:w-[5px] after:bg-[#FF9533] after:rounded-r-2xl"
                          : "text-[#A3A3A3] h-full"
                      } hover:bg-[#EDEDED] hover:text-[#FF9533] hover:after:bg-[#FF9533] after:absolute after:left-0 after:top-0 after:h-full after:w-[5px] after:rounded-r-2xl`
                    }
                    to={item.path}
                    onMouseEnter={() => setIsHovered(index)}
                    onMouseLeave={() => setIsHovered(null)}
                  >
                    <div
                      className={`relative flex items-center py-2 px-4 transition-colors rounded-r-xl h-[60px] ${
                        location.pathname.startsWith(item.path)
                          ? "bg-[#EDEDED]"
                          : ""
                      }`}
                    >
                      <div className="flex items-center justify-center transition-colors">
                        {location.pathname.startsWith(item.path) ||
                        isHovered === index
                          ? React.createElement(item.iconHover)
                          : React.createElement(item.icon)}
                      </div>
                      <span className="ml-4">{item.name}</span>
                    </div>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Asside;
